import getConfig from 'next/config';

const runtimeConfig = getConfig() ? getConfig().publicRuntimeConfig : {};

const { IMGIX_DOMAIN, AWS_BUCKET_DOMAIN } = runtimeConfig;

export default (url) => {
  if (!url) return url;

  const decoded = decodeURI(url).replace('.eu-west-1', '');

  // If the URL contains an AWS bucket domain replace with IMGIX
  if (AWS_BUCKET_DOMAIN && decoded.includes(AWS_BUCKET_DOMAIN)) {
    return decoded.replace(AWS_BUCKET_DOMAIN, IMGIX_DOMAIN);
  }

  // Handle localhost URLs that contain a port number
  try {
    const parsed = new URL(decoded);
    if (parsed.port) {
      return `${parsed.protocol}//${IMGIX_DOMAIN}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    // Not a valid URL, return as-is
  }

  return decoded;
};
